import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as faStarSolid } from "@fortawesome/pro-solid-svg-icons";
import { faStar as faStarOutline } from "@fortawesome/pro-regular-svg-icons";
import { useFieldContext } from "../hooks/surveyResponseFormHooks";

function RatingAnswerOptions() {
    const field = useFieldContext<number | undefined>();
    const [hoverValue, setHoverValue] = useState<number | null>(null);

    const activeValue = hoverValue ?? field.state.value ?? 0;

    return (
        <div className="mb-8 flex flex-col gap-5">
            <div className="flex justify-between" role="radiogroup" aria-label="Rating">
                {[1, 2, 3, 4, 5].map((n) => {
                    const isFilled = n <= activeValue;
                    return (
                        <label
                            key={n}
                            className="flex cursor-pointer flex-col items-center justify-center gap-1 p-1 sm:p-2"
                            onMouseEnter={() => setHoverValue(n)}
                            onMouseLeave={() => setHoverValue(null)}
                        >
                            <input
                                type="radio"
                                value={n}
                                checked={field.state.value === n}
                                onChange={() => field.handleChange(n)}
                                onFocus={() => setHoverValue(n)}
                                onBlur={() => setHoverValue(null)}
                                className="sr-only"
                                id={`${field.name}_${n}`}
                                name={field.name}
                            />
                            <FontAwesomeIcon
                                icon={isFilled ? faStarSolid : faStarOutline}
                                className={`text-4xl transition-colors sm:text-5xl md:text-6xl ${
                                    isFilled ? "text-chameleon-green" : "text-compendia-greige"
                                }`}
                            />
                            <span
                                className={`text-sm transition-colors ${
                                    isFilled
                                        ? "text-chameleon-green font-medium"
                                        : "text-compendia-muted"
                                }`}
                            >
                                {n}
                            </span>
                        </label>
                    );
                })}
            </div>
        </div>
    );
}

export default RatingAnswerOptions;
